import React from 'react';
import { TableBody } from '@mui/material';
import GenericTableRow from './GenericTableRow';

/**
 * גוף הטבלה (TableBody) - ממפה את המערך של currentRows לשורות
 * ומשתמש ב-GenericTableRow להצגה ועריכה של כל שורה.
 */
const GenericTableBody = ({
  currentRows,
  columns,
  columnWidths,
  selectedRows,
  editableRows,
  hasLockedPermission,
  hasRequiredPermission,
  onRowClick,
  onRowSelect,
  onRowEdit,
  onRowDelete,
  onInputChange
}) => {
  return (
    <TableBody>
      {currentRows.map((row, index) => {
        const isSelected = selectedRows.includes(row);
        const isEditable = editableRows.includes(index);

        return (
          <GenericTableRow
            key={index}
            rowData={row}
            rowIndex={index}
            columns={columns}
            columnWidths={columnWidths}
            isSelected={isSelected}
            isEditable={isEditable}
            hasLockedPermission={hasLockedPermission}
            hasRequiredPermission={hasRequiredPermission}
            onRowClick={onRowClick}
            onRowSelect={onRowSelect}
            onRowEdit={onRowEdit}
            onRowDelete={onRowDelete}
            onInputChange={onInputChange}
          />
        );
      })}
    </TableBody>
  );
};

export default GenericTableBody;
